export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7679.58d37f45.jpg";